/**
 * Custom template to hide the default description rendering
 * since we are now showing it as a tooltip in the widget
 */
export const DescriptionFieldTemplate = () => null;
